<main id="content">
    <div id="login">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <img src="/assets/images/logo.png" alt="WellBrain logo" class="logo">
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 no-padding">
                    <div class="form-container" [ngClass]="{'error': loginError}">
                        <div class="error-block">
                            <i class="fa fa-exclamation-triangle"></i>
                            <span class="text">Username, email or password are incorrect. Please try again</span>
                        </div>
                        <header>Log into your account</header>
                        <form novalidate [formGroup]="user" autocomplete="off">
                            <fieldset>
                                <div class="form-group clearfix">
                                    <label class="desktop-show">Username / Email</label>
                                    <input type="username" name="username" placeholder="Write here" autocomplete="off" autocapitalize="off" class="col-xs-12 form-control desktop-show" formControlName="username" [(ngModel)]="model.username">
                                    <input type="username" name="username" placeholder="Username / Email" autocomplete="off" autocapitalize="off" class="col-xs-12 form-control mobile-show" formControlName="username" [(ngModel)]="model.username">
                                </div>
                                <div class="form-group clearfix">
                                    <label class="desktop-show">Password</label>
                                    <input type="password" name="password" placeholder="Write here" autocomplete="off" autocapitalize="off" class="col-xs-12 form-control desktop-show" formControlName="password" [(ngModel)]="model.password">
                                    <input type="password" name="password" placeholder="Password" autocomplete="off" autocapitalize="off" class="col-xs-12 form-control mobile-show" formControlName="password" [(ngModel)]="model.password">
                                </div>
                            </fieldset>
                            <div class="wrap">
                                <button type="submit" class="btn btn-primary login-btn" (click)="login()" [disabled]="!user.valid">Log in</button><a href="/#/password-reset" class="forgot"></a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 footer">
                    <a href="http://wellbrain.io">Want to learn more about WellBrain ?</a>
                    <p>By clicking on the LOGIN BUTTON you agree to our<a href="/#/terms-and-conditions">Terms &amp; Conditions</a>, <a href="/#/medical-disclaimer">Medical Disclaimer</a> and <a href="/#/privacy-policy" class="privacy-policy"></a></p>
                </div>
            </div>
        </div>
    </div>
</main>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/login/login.component.html